module.exports = __webpack_public_path__ + "static/media/FreddyLaugh2.9d962f5d.mp3";